import React, { useEffect } from "react";
import CareTeamRow from "./CareTeamRow";
import { useDispatch, useSelector } from "react-redux";
import { team } from "redux-store/care-team/care-team.selector";
import { useNavigate } from "react-router-dom";
import { getUserteams } from "redux-store/care-team/care-team.slice";
import { AppDispatch } from "redux-store/store";
import { updateKit, messageClean, errorClean } from "redux-store/kit/kit.slice";
import { successMessage, kitError, kitActivityInProcess } from "redux-store/kit/kit.selector";

type Propstype = {
  changeStep?: any;
  setKitData?: any;
  kitData?: any;
};

const StepThree = ({ changeStep, setKitData, kitData }: Propstype) => {
  const teams = useSelector(team);
  const updateMessage = useSelector(successMessage);
  const activateErrorMessage = useSelector(kitError);
  const activity = useSelector(kitActivityInProcess);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(errorClean());
    dispatch(messageClean());
    dispatch(getUserteams());
  }, []);

  useEffect(() => {
    if (activateErrorMessage.message === "Kit already activated") {
      setTimeout(() => changeStep("step2"), 2000);
    }
  }, [activateErrorMessage]);

  const handleUpdateKit = () => {
    if (kitData.petId !== "" && kitData.code !== 0) {
      if (updateMessage !== "") {
        dispatch(messageClean());
      }
      dispatch(updateKit(kitData));
    }
  };
  return (
    <div>
      {/* table col */}
      <div className="tw-flex tw-flex-col tw-overflow-x-hidden md:tw-overflow-x-auto tw-overflow-y-auto tw-w-full lg:tw-w-[95%] tw-h-[50vh] lg:tw-h-[300px] activate-table">
        {/* 1st row */}
        <div className="tw-flex tw-items-center tw-mb-5 tw-pl-[40px]">
          {/* attributes row */}
          <div className="tw-w-full lg:tw-w-[90%] tw-flex tw-gap-6 lg:tw-gap-20 tw-items-center">
            {/* <div className="tw-hidden tw-w-fit">
              <div className="tw-invisible tw-w-4 lg:tw-w-8 tw-h-4 lg:tw-h-8 tw-bg-reddishOrange tw-flex tw-item-center">
                <img src={CheckedSVG} alt="checked tick" />
              </div>
            </div> */}
            <div className="tw-hidden md:tw-flex-1 md:tw-flex tw-gap-6">
              <div className="tw-flex-[2] tw-text-[1rem] lg:tw-text-[1.375rem] tw-font-bold lg:tw-leading-[1.625rem] tw-text-darkPurple">
                Hospital Name
              </div>
              <div className="tw-flex-[2] tw-text-[1rem] lg:tw-text-[1.375rem] tw-font-bold lg:tw-leading-[1.625rem] tw-text-darkPurple">
                Veterinarian Name
              </div>
              <div className="tw-flex-[2] tw-text-[1rem] lg:tw-text-[1.375rem] tw-font-bold tw-leading-[1.625rem] tw-text-darkPurple">
                Email
              </div>
            </div>
          </div>
        </div>

        {/* 2nd row */}
        <div className="tw-flex tw-flex-col tw-gap-6 tw-h-auto">
          {teams && teams.length !== 0 ? (
            teams.map((team) => (
              <CareTeamRow
                careTeamId={team._id}
                hospName={team.hospitalName}
                vetName={team.veterinarianName}
                email={team.email}
                kitData={kitData}
                setKitData={setKitData}
              />
            ))
          ) : (
            <span className="tw-pl-[50px]">No Veterinarian Found.</span>
          )}
        </div>
      </div>
      {/* button col */}
      <div className="tw-flex-1 tw-mt-10 tw-flex tw-items-center tw-justify-end">
        {updateMessage !== "" ? (
          <>
            <span className="tw-text-2xl tw-font-700 tw-text-green-600 tw-text-center">{updateMessage}</span>
          </>
        ) : (
          <div className=" tw-flex tw-flex-col tw-gap-2">
            <span className="tw-text-lg tw-text-red-600">
              {activateErrorMessage && activateErrorMessage.message !== "" ? activateErrorMessage.message : ""}
            </span>
            <div className=" tw-text-end tw-flex tw-space-x-2 md:tw-space-x-0">
              <button className="md:tw-hidden tw-py-2 tw-px-3 lg:tw-px-6 tw-rounded-[0.625rem] tw-text-xs lg:tw-text-[1.25rem] tw-font-bold tw-border-2 tw-border-solid tw-border-darkRed">
                <span
                  onClick={() => {
                    navigate(`/user/care-team/add-care-team/add/activate`, {
                      state: kitData,
                    });
                  }}
                >
                  Add Vet Info
                </span>
              </button>
              <button
                className=" tw-bg-reddishOrange tw-text-white tw-py-2 md:tw-py-4 tw-px-3 md:tw-px-6 lg:tw-px-10 tw-rounded-[0.625rem] tw-text-xs lg:tw-text-[1.25rem] tw-font-bold"
                onClick={handleUpdateKit}
              >
                {activity ? "Activating.." : "Complete Activation"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StepThree;
